import React, { Component } from 'react';
import Navbar from './components/Navbar';
import AboutMeImageSection from './components/AboutMeImageSection';
import SectionContactUsForm from './components/SectionContactUsForm';
import Footer from './components/Footer';
import { aboutMe } from './data';
import NotFound from './components/NotFound'

import ReactGA from 'react-ga';

class AboutMePage extends Component {

  constructor() {
    super();
    ReactGA.initialize('UA-93233224-1');
    ReactGA.pageview(window.location.pathname);
  }

  render() {
    ReactGA.pageview(window.location.pathname);
    const {erinWalerko, lindaVollmer, contactUs} = aboutMe;

    const person = this.props.params.person;

    const personFound = (
        <div className='about-me-page sticky-nav-always' id='home'>
          <Navbar />
          <AboutMeImageSection aboutMeInfoData={person === 'erin-walerko' ? erinWalerko : lindaVollmer}/>
          <SectionContactUsForm contactUsData={contactUs}/>
          <Footer />
        </div>
      )

    return (
      person === 'erin-walerko' || person === 'linda-vollmer' ? personFound : <NotFound />

    )
  }
}

AboutMePage.propTypes = {
  params: React.PropTypes.object.isRequired
}

export default AboutMePage;



// WEBPACK FOOTER //
// ./src/AboutMePage.js